import React from 'react'
import { Box, Typography, Link } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { CoreButton } from '../core'
import { Icon } from '@iconify/react'
import useTrackerFunction from 'src/hooks/useTrackerFunction'

const KnowledgeBase = ({ classes }) => {
  // Tracking functions
  const trackKnowledgeBaseLink = useTrackerFunction(
    'clicked_knowledge_base_link',
    {
      source: 'knowledge_base',
    },
  )
  const trackMoreResources = useTrackerFunction('clicked_more_resources', {
    source: 'knowledge_base',
  })
  const trackIntercomOpen = useTrackerFunction('clicked_intercom', {
    source: 'knowledge_base',
  })
  const trackWhatsNew = useTrackerFunction('clicked_whats_new', {
    source: 'knowledge_base',
  })
  const trackSocialLink = useTrackerFunction('clicked_social_link', {
    source: 'knowledge_base',
  })

  const handleIntercomOpen = () => {
    trackIntercomOpen()
    if (window.Intercom) {
      window.Intercom('showMessages')
    }
  }

  const handleLinkClick = (link, type) => {
    switch (type) {
      case 'knowledge_base':
        trackKnowledgeBaseLink({ link_title: link.title })
        break
      case 'whats_new':
        trackWhatsNew({ link_title: link.title })
        break
      case 'social':
        trackSocialLink({ platform: link.title })
        break
      default:
        break
    }
  }

  const links = [
    {
      icon: 'famicons:link-outline',
      title: 'Customizing Links with Custom Domain (CNAME)',
      backgroundColor: 'E7F6FF',
      link:
        'https://minicoursegenerator.com/knowledge-base/customizing-links-with-custom-domain-cname/',
    },
    {
      icon: 'solar:card-outline',
      title: 'Enable access behind a paywall',
      backgroundColor: '#FFF1DE',
      link:
        'https://minicoursegenerator.com/knowledge-base/sell-mini-courses-online/',
    },
    {
      image: '/assets/AI-assistant-dark.svg',
      title: 'How do the AI credits work?',
      backgroundColor: '#EBEBFF',
      link:
        'https://minicoursegenerator.com/knowledge-base/how-do-the-ai-credits-work/',
    },
  ]
  const feedback = [
    {
      icon: 'fluent:person-feedback-16-regular',
      title: 'We shape our roadmap with your feedback and questions.',
    },
  ]
  const whatsNew = [
    {
      icon: 'fluent:news-28-regular',
      title: 'Check latest product updates, new features, and improvements.',
      backgroundColor: '#FFF6D7',
      link: 'https://mcg.noticeable.news',
    },
  ]
  const socialLinks = [
    {
      icon: 'logos:youtube-icon',
      title: 'Learn with our video guides',
      link: 'https://www.youtube.com/@MiniCourseGeneratorWithAI',
    },
    {
      icon: 'logos:linkedin-icon',
      title: 'Stay connected with our community',
      link: 'https://www.linkedin.com/company/mini-course-generator/',
    },
  ]

  return (
    <Box className={classes.knowledgeBase}>
      {/* Knowledge base section */}
      <Box className={classes.knowledgeSection}>
        <Typography className={classes.sectionTitle}>Knowledge base</Typography>

        {links.map(link => (
          <Link
            href={link.link}
            target="_blank"
            className={classes.linkItem}
            key={link.title}
            onClick={() => handleLinkClick(link, 'knowledge_base')}
          >
            <div
              style={{
                backgroundColor: link.backgroundColor,
                borderRadius: '8px',
                padding: '8px',
              }}
            >
              {link.image ? (
                <img
                  src={link.image}
                  alt={link.title}
                  className={classes.icon}
                />
              ) : (
                <Icon icon={link.icon} className={classes.icon} />
              )}
            </div>
            <Typography className={classes.linkText}>{link.title}</Typography>
          </Link>
        ))}

        <CoreButton
          variant="outlined"
          color="secondary"
          href="https://minicoursegenerator.com/knowledge-base/"
          target="_blank"
          className={classes.moreResourcesButton}
          onClick={() => trackMoreResources()}
        >
          More resources
        </CoreButton>
      </Box>

      {/* Have questions section */}
      <Box className={classes.knowledgeSection}>
        <Typography className={classes.sectionTitle}>
          Have questions or feedback?
        </Typography>

        <Box className={classes.feedbackBox}>
          {feedback.map(feedback => (
            <Link
              href={feedback.link}
              className={classes.linkItem}
              key={feedback.title}
              target="_blank"
            >
              <div className={classes.feedbackIcon}>
                <Icon icon={feedback.icon} className={classes.icon} />
              </div>
              <Typography className={classes.linkText}>
                {feedback.title}
              </Typography>
            </Link>
          ))}
        </Box>

        <CoreButton
          onClick={handleIntercomOpen}
          variant="outlined"
          color="secondary"
        >
          Let us know
        </CoreButton>
      </Box>
      <Box className={classes.knowledgeSection}>
        <Typography className={classes.sectionTitle}>What's new</Typography>
        {whatsNew.map(whatsNew => (
          <div
            className={classes.linkItem}
            onClick={() => handleLinkClick(whatsNew, 'whats_new')}
          >
            <div
              style={{
                backgroundColor: whatsNew.backgroundColor,
                borderRadius: '8px',
                padding: '8px',
              }}
            >
              <Icon icon={whatsNew.icon} className={classes.icon} />
            </div>
            <Typography className={classes.linkText}>
              {whatsNew.title}
            </Typography>
          </div>
        ))}
        <CoreButton
          variant="outlined"
          color="secondary"
          href="https://mcg.noticeable.news"
          target="_blank"
          onClick={() => trackWhatsNew({ link_title: 'Learn more' })}
        >
          Learn more
        </CoreButton>
      </Box>
      {/* Connect with us section */}
      <Box className={classes.knowledgeSection}>
        <Typography className={classes.sectionTitle}>
          Connect with us!
        </Typography>

        {socialLinks.map(socialLink => (
          <Link
            href={socialLink.link}
            className={classes.linkItem}
            key={socialLink.title}
            target="_blank"
            onClick={() => handleLinkClick(socialLink, 'social')}
          >
            <div className={classes.feedbackIcon}>
              <Icon icon={socialLink.icon} className={classes.icon} />
            </div>
            <Typography className={classes.linkText}>
              {socialLink.title}
            </Typography>
          </Link>
        ))}
      </Box>
    </Box>
  )
}

export default withStyles(styles)(KnowledgeBase)
